import React, { Component, useContext, useEffect, useState } from "react";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import Footer from "../components/Footer";
import Header from "../components/Header";
import Menu from "../components/Menu";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import StarekContext from "../context/StarekContext";
import { useNavigate, Navigate } from "react-router-dom";

const AppLayout = (props) => {
    const starekContext = useContext(StarekContext);
    const Alert = React.forwardRef(function Alert(props, ref) {
        return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
    });

    const handleClose = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }
        starekContext.setMessage(null);
    };
    return starekContext?.auth ? (
        <>
            <div className="wrapper">
                <Header></Header>
                <Menu></Menu>
                <div className="content-wrapper" style={{ minHeight: 333 }}>
                    <Stack
                        spacing={2}
                        sx={{ width: "100%" }}
                        className="tw-mt-4"
                    >
                        <Snackbar
                            anchorOrigin={{
                                vertical: "top",
                                horizontal: "center",
                            }}
                            open={starekContext.message != null}
                            autoHideDuration={6000}
                            onClose={handleClose}
                        >
                            {starekContext.message && (
                                <Alert
                                    onClose={handleClose}
                                    severity={
                                        starekContext.snackbarNotification?.type
                                    }
                                    sx={{
                                        width: "100%",
                                        backgroundColor:
                                            starekContext.snackbarNotification
                                                ?.type === "info"
                                                ? "var(--bs-info)"
                                                : starekContext
                                                      .snackbarNotification
                                                      ?.type === "warning"
                                                ? "var(--bs-warning)"
                                                : starekContext
                                                      .snackbarNotification
                                                      ?.type === "error"
                                                ? "var(--bs-danger)"
                                                : undefined,
                                        fontWeight: 700,
                                        "& .MuiAlert-message": {
                                            color:
                                                starekContext
                                                    .snackbarNotification
                                                    ?.type === "warning"
                                                    ? "var(--bs-dark)"
                                                    : "#fff !important",
                                        },
                                    }}
                                >
                                    {starekContext.snackbarNotification?.text}
                                </Alert>
                            )}
                        </Snackbar>
                    </Stack>
                    {props.children}
                </div>
                <Footer></Footer>
            </div>
        </>
    ) : (
        <Navigate to={"/login"}></Navigate>
    );
};

export default AppLayout;
